/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateUploadDto } from '../models/work-create-upload-dto';
import { WorkCreateUploadsDto } from '../models/work-create-uploads-dto';
import { WorkUpload } from '../models/work-upload';

@Injectable({ providedIn: 'root' })
export class WorkUploadsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `uploadsV1ControllerUploadFile()` */
  static readonly UploadsV1ControllerUploadFilePath = '/v1/uploads/upload';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadsV1ControllerUploadFile()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadsV1ControllerUploadFile$Response(
    params: {
      body: WorkCreateUploadDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkUpload>> {
    const rb = new RequestBuilder(this.rootUrl, WorkUploadsService.UploadsV1ControllerUploadFilePath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkUpload>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `uploadsV1ControllerUploadFile$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadsV1ControllerUploadFile(
    params: {
      body: WorkCreateUploadDto
    },
    context?: HttpContext
  ): Observable<WorkUpload> {
    return this.uploadsV1ControllerUploadFile$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkUpload>): WorkUpload => r.body)
    );
  }

  /** Path part for operation `uploadsV1ControllerUploadAndSendAsPdfByMail()` */
  static readonly UploadsV1ControllerUploadAndSendAsPdfByMailPath = '/v1/uploads/uploadAndSendAsPdfByMail';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadsV1ControllerUploadAndSendAsPdfByMail()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadsV1ControllerUploadAndSendAsPdfByMail$Response(
    params: {
      body: WorkCreateUploadsDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkUploadsService.UploadsV1ControllerUploadAndSendAsPdfByMailPath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `uploadsV1ControllerUploadAndSendAsPdfByMail$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadsV1ControllerUploadAndSendAsPdfByMail(
    params: {
      body: WorkCreateUploadsDto
    },
    context?: HttpContext
  ): Observable<void> {
    return this.uploadsV1ControllerUploadAndSendAsPdfByMail$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `uploadsV1ControllerGetUploadedFileById()` */
  static readonly UploadsV1ControllerGetUploadedFileByIdPath = '/v1/uploads/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadsV1ControllerGetUploadedFileById()` instead.
   *
   * This method doesn't expect any request body.
   */
  uploadsV1ControllerGetUploadedFileById$Response(
    params: {
      id: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkUploadsService.UploadsV1ControllerGetUploadedFileByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `uploadsV1ControllerGetUploadedFileById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  uploadsV1ControllerGetUploadedFileById(
    params: {
      id: string;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.uploadsV1ControllerGetUploadedFileById$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `uploadsV1ControllerDeleteUploadedFileById()` */
  static readonly UploadsV1ControllerDeleteUploadedFileByIdPath = '/v1/uploads/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadsV1ControllerDeleteUploadedFileById()` instead.
   *
   * This method doesn't expect any request body.
   */
  uploadsV1ControllerDeleteUploadedFileById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(this.rootUrl, WorkUploadsService.UploadsV1ControllerDeleteUploadedFileByIdPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `uploadsV1ControllerDeleteUploadedFileById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  uploadsV1ControllerDeleteUploadedFileById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<boolean> {
    return this.uploadsV1ControllerDeleteUploadedFileById$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
